import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'CLUSTERS',
    itemActionName: 'CLUSTER',
});
